// extracted by mini-css-extract-plugin
module.exports = {"job-stage-container":"styles-module__job-stage-container___3IX-I","template-title":"styles-module__template-title___ifoDL"};